import { FC } from "react";
import Feedback from "./feedback/Feedback";

export const Footer: FC = () => {
    const today = new Date();

    return (
        <div className="alice-footer">
            <div id="copyright">
                <img className="uhm-logo" src={process.env.PUBLIC_URL + "/images/UHM.svg"} alt="Uhm footer logo" />
                <p>&copy;{today.getFullYear()} Union Home Mortgage</p>
            </div>

        </div>
    );
}

export default Footer;